var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "chartWrapper",
      staticStyle: {
        width: "100%",
        position: "relative",
        "overflow-x": "hidden",
      },
    },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.renderAs === "svg",
            expression: "renderAs === 'svg'",
          },
        ],
        ref: "chart",
      }),
      _c("canvas", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.renderAs === "canvas",
            expression: "renderAs === 'canvas'",
          },
        ],
        ref: "canvas",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }